'use client'
import { type FC } from 'react'
import { MODALS } from '@/context'
import { useModal, useTranslator } from '@/hooks'
import { css } from 'styled-components'
import { FormFilters } from '../forms/FormFilters'
import dynamic from 'next/dynamic'
import { mq } from '@/styles'

const DynamicModal = dynamic(() =>
  import('@/components/base/Modal').then(
    (mod) => mod.Modal
  ), { ssr: false }
)

const dialogFromRightVariants = (isActive: boolean) => ({
  initial: { x: '100%' },
  animate: { x: isActive ? 0 : '100%' },
  exit: { x: '100%' },
  transition: { duration: .3 }
})

export const ModalFilters:FC = () => {
  const { isActive, closeClearingPayload } = useModal(MODALS.FILTERS)
  const { t } = useTranslator()

  return (
    <DynamicModal isActive={isActive} close={closeClearingPayload} xAlign='flex-end' hasHeader={true} size='xs' zIndex={9999} dialogStyles={dialogStyles} variants={dialogFromRightVariants} title={t('project.modals.filters.title') as string} hasToClose={true}>
      <FormFilters />
    </DynamicModal>
  )
}


const dialogStyles = css`
  background-color: var(--color-background);

  .modal__body {
    height: calc(100vh - 48px);
    height: calc(100dvh - 48px);
    overflow-y: auto;
    padding: 20px 10px 50px;
    position: relative;

		${mq.greaterThan('mobile')} {
			padding: 20px 20px 50px;
		}

		${mq.greaterThan('tablet')} {
			padding: 20px 35px 50px;
		}

    &:after {
      background-color: var(--color-background);
      background: linear-gradient(0deg, var(--color-background) 0%, var(--color-background) 40%, rgba(255, 255, 255, 0) 100%);
      bottom: -50px;
      content: '';
      display: block;
      height: 96px;
      left: 0;
      opacity: 1;
      position: sticky;
      right: 0;
      width: 100%;
    }
  }
`
